var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.service.length !== 0)?_c('div',{staticClass:"service--insurance"},[_c('b-row',[_c('b-col',{attrs:{"offset-md":"1"}},[_c('div',{staticClass:"service--insurance--wrapper"},[_c('b-form-group',{attrs:{"id":"freetext"}},[_c('tiny-mce',{attrs:{"preview_mode":true,"height":400,"block_title":'Informazioni servizio',"initial_value":this.insurance_service.details.freetext},on:{"input":function (value) {
                            this$1.insurance_service.details.freetext = value
                            this$1.update_service()
                        }}})],1)],1)]),_c('b-col',{attrs:{"md":"4"}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }